/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}

.calendar {
  margin-block-end: 0.25rem;
}

.week-headers {
  display: flex;
  border-width: 0px;
  border-block-start-width: 1px;
  border-style: solid;
  border-color: var(--calcite-color-border-3);
  padding-block: 0px;
  padding-inline: 0.25rem;
}

.week-header {
  text-align: center;
  font-weight: var(--calcite-font-weight-bold);
  color: var(--calcite-color-text-3);
  inline-size: 14.2857142857%;
}

.day {
  display: flex;
  min-inline-size: 0px;
  justify-content: center;
  inline-size: 100%;
}
.day calcite-date-picker-day {
  inline-size: 100%;
}

:host([scale=s]) .week-header {
  padding-inline: 0px;
  padding-block: 0.5rem 0.75rem;
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
}

:host([scale=m]) .week-header {
  padding-inline: 0px;
  padding-block: 0.75rem 1rem;
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
}

:host([scale=l]) .week-header {
  padding-inline: 0px;
  padding-block: 1rem 1.25rem;
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
}

.week-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-auto-rows: 1fr;
  padding-block: 0;
  padding-inline: 6px;
}
.week-days:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}